import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Popover, PopoverModule } from 'primeng/popover';
import { DatePickerModule } from 'primeng/datepicker';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { addDays } from 'date-fns';

import { LanguageService } from '@shared/services/language.service';

@Component({
  selector: 'app-date-picker',
  standalone: true,
  imports: [CommonModule, PopoverModule, TranslateModule, DatePickerModule, FormsModule, ButtonModule],
  templateUrl: './date-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    },
  ],
})
export class DatePickerComponent implements ControlValueAccessor {
  @Input() public selectionMode: 'single' | 'multiple' | 'range' = 'single';
  @Input() public maxRangeDays: number;
  @Input() public maxSelectableDays: number;
  @Input() public label: string = this.translateService.instant('date');

  public _value: any; // Date | Date[]

  public readonly langauge: string = this.languageService.current;
  @Input() public maxDate: Date | null = new Date();

  constructor(private languageService: LanguageService, private translateService: TranslateService,) {}

  writeValue(value: Date): void {
    this._value = value;
  }

  registerOnChange(fn: (value: Date) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onDateChange(value: any, op: Popover): void {
    this._value = value;
    this.onChange(value);
    this.onTouched();

    if (this.selectionMode === 'range' && this.maxRangeDays && value?.length) {
      this.maxDate = addDays(value[0], this.maxRangeDays);
    } else {
      this.maxDate = new Date();
    }
    if (this.selectionMode !== 'range') {
      op.hide();
    }
  }

  private onChange: (value: Date) => void = () => {};
  private onTouched: () => void = () => {};

}
